module.exports = __webpack_public_path__ + "static/media/dell1.8f936b2c.svg";